import { Component } from "@angular/core";

@Component({
  selector: "app-availability-code-detail",
  templateUrl: "./availability-code-detail.component.html",
  styleUrls: ["./availability-code-detail.component.css"]
})
export class AvailabilityCodeDetailComponent {
  constructor() {}
}
